

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _credit = require('xo-models/src/credit');

var _checkout = require('xo-models/src/checkout');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$capeRedirectUtil', function () {
    return {
        handleCapeRouting: function handleCapeRouting(checkoutSession, checkoutCart, token) {
            var checkoutAppData = _checkout.$CheckoutAppDataModel.instance(token);
            var checkoutCartModel = _checkout.$CheckoutCartModel.instance(token);
            var checkoutPayeeModel = _checkout.$CheckoutPayeeModel.instance(token);
            var creditDataModel = _credit.$CreditDataModel.instance(token);
            var selectedInstallmentModel = _credit.$CreditInstallmentModel.instance(token); // Only tracks selected financing option
            var merchantCountry = checkoutAppData.get('merchant.merchant_country');

            (0, _angular.$q)(function (resolve, reject) {
                if (checkoutAppData.isSecondButton()) {

                    _angular.$q.all([(0, _squid.$elmo)('xo_us_ppc_ezp', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': checkoutPayeeModel.getId()
                    }, 'Trmt_xo_us_ppc_.*', false, true), (0, _squid.$elmo)('xo_gb_ppc_cape_cyco', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': checkoutPayeeModel.getId()
                    }, 'Trmt_xo_gb_ppc_cape_cyco', false, true)]).then(function (_ref) {
                        var ppcEZPRes = _ref[0],
                            redirectToCape = _ref[1];

                        resolve({ ppcEZPRes: ppcEZPRes, redirectToCape: redirectToCape });
                    })['catch'](function (err) {
                        reject(err);
                    });
                } else {
                    resolve();
                }
            }).then(function (_ref2) {
                var ppcEZPRes = _ref2.ppcEZPRes,
                    redirectToCape = _ref2.redirectToCape;

                var fundingInstruments = void 0;
                var isCreditInWallet = void 0;

                var redirectToCapeCyco = redirectToCape || ppcEZPRes;
                var ppcEZPTreatment = ppcEZPRes && ppcEZPRes.treatment_name;
                var redirectToCapeCycoTreatment = redirectToCape && redirectToCape.treatment_name;

                _logger.$logger.info('checkout_fpti', {
                    'xo_us_ppc_ezp': ppcEZPTreatment ? ppcEZPTreatment : 'Ctrl_xo_us_ppc_cape_cyco'
                });

                _logger.$logger.info('checkout_fpti', {
                    'xo_gb_ppc_cape_cyco': redirectToCapeCycoTreatment ? redirectToCapeCycoTreatment : 'Ctrl_xo_gb_ppc_cape_cyco'
                });

                if (checkoutCart.isBillingNoPurchase()) {
                    fundingInstruments = checkoutSession.futurePaymentInstruments;
                    isCreditInWallet = checkoutSession.futurePayment && checkoutSession.futurePayment.isCreditInWallet;
                } else {
                    fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
                    isCreditInWallet = fundingInstruments && _squid.$util.find(fundingInstruments, function (fi) {
                        return fi.name === 'BILL_ME_LATER';
                    });
                }

                var isCapeReturnKey = creditDataModel.getCapeKey();
                var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');
                var isPPCEligible = checkoutSession.creditOffer;

                if (_squid.$locale.country !== checkoutAppData.get('merchant.merchant_country')) {
                    creditDataModel.setCrossBorder(true);
                }

                function handleRedirect(hasInstallmentOptions, hasThreeMonthInstallment) {
                    // User does not have any FI in wallet but they choose to pay in full.
                    // Show add card contingency page instead of redirecting to CAPE.
                    if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {
                        return _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                    }

                    // Handle return from CAPE
                    else if (isCapeReturn || creditDataModel.payInFull) {
                            return _uiRouter.$state.go('checkout.review');
                        }

                        // CYCO and Login swap
                        else if (!redirectToCapeCyco && checkoutAppData.isSecondButton() && hasInstallmentOptions && !hasThreeMonthInstallment) {
                                // Redirect to CYCO for reuse & acq 2nd button
                                return _uiRouter.$state.go('checkout.chooseCreditOffer');
                            }

                            // CYCO and Login swap
                            else if (checkoutAppData.isSecondButton() && hasInstallmentOptions) {
                                    // Redirect to CYCO for reuse & acq 2nd button with installments
                                    if (!redirectToCapeCyco && !hasThreeMonthInstallment) {
                                        _logger.$logger.info('redirecting_to_cyco_2nd_button');
                                        return _uiRouter.$state.go('checkout.chooseCreditOffer');
                                    } else if (isCreditInWallet && !redirectToCapeCyco && hasThreeMonthInstallment) {
                                        _logger.$logger.info('redirecting_to_review_reuse_2nd_button');
                                        return _uiRouter.$state.go('checkout.review');
                                    } else {
                                        var showCapeCyco = Boolean(redirectToCapeCyco);

                                        _logger.$logger.info('redirecting_to_cape_cyco_2nd_button', {
                                            showCapeCyco: showCapeCyco,
                                            hasThreeMonthInstallment: hasThreeMonthInstallment
                                        });

                                        return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: showCapeCyco });
                                    }
                                }

                                // Reuse scenario
                                else if (isCreditInWallet) {
                                        _logger.$logger.info('redirecting_to_review_reuse_2nd_button');
                                        return _uiRouter.$state.go('checkout.review');
                                    }

                                    // Acquisition scenario
                                    else if (isPPCEligible) {
                                            var _showCapeCyco = Boolean(redirectToCapeCyco) && hasInstallmentOptions;

                                            _logger.$logger.info('redirecting_to_cape_acq_2nd_button', {
                                                showCapeCyco: _showCapeCyco,
                                                hasThreeMonthInstallment: hasThreeMonthInstallment,
                                                hasInstallmentOptions: hasInstallmentOptions
                                            });

                                            return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: _showCapeCyco });
                                        } else {
                                            // show error message
                                            return _uiRouter.$state.go('checkout.review');
                                        }
                }

                // 2nd button, cross border, installment offer selected in API -- we cannot honor any offer the user chose, so must clear offer
                if (checkoutAppData.isSecondButton() && creditDataModel.isCrossBorder() && selectedInstallmentModel.get('meta.populated')) {
                    selectedInstallmentModel.action('delete', {
                        success: function success(result) {
                            _logger.$logger.info('patch_cart_installment_success');
                            _credit.$CreditInstallmentModel.create(token); // Clear cache for this token
                            handleRedirect(false, false);
                        },
                        error: function error(err) {
                            _logger.$logger.error('patch_cart_installment_fail', err);
                            _uiRouter.$state.go('checkout.genericError', {
                                code: 'DELETE_CREDIT_OPTION_ERROR'
                            });
                        }
                    });
                } else {
                    var offers = new _credit.$CreditInstallmentOptionsModel({
                        id: token,
                        payee: checkoutPayeeModel,
                        checkoutCart: checkoutCartModel,
                        checkoutAppData: checkoutAppData,
                        isMemberCredit: true
                    });

                    return offers.save({
                        cache: true,
                        success: function success(result) {
                            var hasInstallmentOptions = offers.getInstallmentOptionsPresent();
                            var installmentOfferDetails = offers.getInstallmentOffers();

                            installmentOfferDetails = installmentOfferDetails && installmentOfferDetails.installment_options;

                            var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                            var installmentOfferDetailsArray = installmentOfferDetails ? installmentOfferDetails.map(function (item) {
                                return item.financingCode;
                            }) : [];
                            var hasThreeMonthInstallment = Boolean(installmentOfferDetailsArray.filter(function (value) {
                                return threeMonthFinancingCodeArray.includes(value);
                            }).length > 0);

                            handleRedirect(hasInstallmentOptions, hasThreeMonthInstallment);
                        }
                    });
                }
            });
        }
    };
});

_angular.$q;

_squid.$util;

_squid.$locale;

_squid.$elmo;

_squid.$feature;

_uiRouter.$state;

_logger.$logger;

_credit.$CreditDataModel;

_credit.$CreditInstallmentModel;

_credit.$CreditInstallmentOptionsModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/util.js
// module id = ./pages/xo-login/util.js
// module chunks = main-code-split